<template>
  <div>
    <div v-for="page in pages" :key="page">
      <p class="onetitle">退 仓 单</p>
      <div class="form-logo">
        <div><img :src="form.logoUrl" alt=""></div>
        <div>
          <div style="font-size: normal">
            {{ form.fCompany }}
          </div>
          <div
            style="
              font-size: 12px;
              -webkit-transform: scale(0.7);
              -webkit-transform-origin-x: 0;
            "
          >
            {{ form.fCompanyEnglish }}
          </div>
        </div>
      </div>
      <div class="form-info">
        <div>经销商：{{ form.fDistributor }}</div>
        <div>
          客户名称：{{ form.fCustomer }}
          <span>日期：{{ fmtDateTime(form.fDate) }}</span>
          <span>NO：{{ form.fBillNo }}</span>
        </div>
      </div>
      <table class="form-table">
        <thead>
          <tr style="font-size: 10px">
            <th style="width: 18mm">产品编号</th>
            <th>产品名称</th>
            <th>规格</th>
            <th style="width: 8mm">单位</th>
            <th style="width: 12mm">数量</th>
            <th style="width: 18mm">生产日期</th>
            <th style="width: 18mm">批号</th>
            <th style="width: 18mm">消毒日期</th>
            <th style="width: 60mm">备注</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in items(page)"
            :key="index"
            style="text-align: center; font-size: 8px"
          >
            <td>{{ item.fNumber }}</td>
            <td>{{ item.fName }}</td>
            <td>{{ item.fModel }}</td>
            <td>{{ item.fUnit }}</td>
            <td>{{ item.fQty }}</td>
            <td>{{ item.fDate_Sc }}</td>
            <td>{{ item.fBatchNo }}</td>
            <td>{{ item.fDate_Xd }}</td>

            <td>{{ item.fDes }}</td>
          </tr>
        </tbody>
      </table>
      <div class="form-foot">
        <span>记账：{{ form.jz }}</span>
        <span>会计：{{ form.kj }}</span>
        <span>出纳：{{ form.cn }}</span>
        <span>部门主管：{{ form.bmzg }}</span>
        <span>保管：{{ form.bg }}</span>
        <span>制单人：{{ form.createName }}</span>
      </div>
      <div
        style="text-align: center; margin-top: 5px; page-break-after: always"
      >
        <div>{{ page + 1 }}/{{ pages.length }}</div>
        <div>
          <span style="float: right; font-weight: bold; font-size: 14px">
            {{ form.fControlledNumber }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Now, Today, DeepCopy } from '@assets/site'
import moment from 'moment'

export default {
  data: function() {
    return {
      form: {
        entrys: []
      },
      loading: false,
      pageSize: 5
    }
  },
  computed: {
    pages: function() {
      var count = Math.ceil(this.form.entrys.length / this.pageSize)
      var rtn = []
      for (let i = 0; i < count; i++) {
        rtn.push(i)
      }
      // console.log('pages', rtn)
      return rtn
    }
  },

  methods: {
    refresh: async function(fid) {
      this.loading = true
      const res = await this.$httpPost(
        'SaleRetrun/SaleRetrunBill/SaleRetrunBillPrint',
        {
          fid: fid
        }
      ).finally(() => (this.loading = false))

      if (!res.isSuccess) {
        this.$message.error(res.message)
        return
      }
      this.form = res.datalist
      return true
    },
    items: function(page) {
      var rtn = []
      for (let i = 0; i < this.pageSize; i++) {
        const itemIdx = page * this.pageSize + i
        if (itemIdx >= this.form.entrys.length) break
        const item = this.form.entrys[itemIdx]
        rtn.push(item)
      }
      return rtn
    },
    fmtDateTime: function(dt) {
      var m = moment(dt, 'YYYY-MM-DD HH:mm:ss')
      return m.format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>

<style lang="less" scoped>
.onetitle {
  font-weight: bold;
  font-size: 25px;
  font-family: 华文行楷;
  text-align: center;
  margin: 0;
}

.form-logo {
  display: flex;
  align-items: center;
}

.form-info {
  font-size: 10px;
  margin-bottom: 5px;
  span {
    float: right;
    margin-left: 35px;
  }
}

.form-table {
  width: 100%;
  border-collapse: collapse;
}

.form-table,
th {
  border: 1px solid black;
  font-size: small;
}
.form-table,
td {
  border: 1px solid black;
}
.form-foot {
  display: flex;
  font-size: 10px;
  margin-top: 5px;
  text-align: center;
  span {
    flex: 1;
    justify-content: space-between;
  }
}
</style>
<style media='print' scoped>

  @page {
  margin: 1cm 4cm 0 1cm ;

  }

</style>
